export default __webpack_public_path__ + "static/media/pic8.1ec69f05.jpg";